<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showPage="false"
               tableApi="admin/my_company/getAdminUser"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="account">
          <Input type="text" v-model="searchData.account" placeholder="账号或昵称" class="lx-search-item"></Input>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem>
      </template>
    </pageTable>

    <user-edit v-if="showEditUser"
            :show-edit-user="showEditUser"
            :user-id="editUserId"
            ref="userEdit"
            @cancel-edit="cancelEdit"
            @edit-success="editSuccess"
    >
    </user-edit>

  </div>
</template>

<script>
  import userEdit from "./edit";
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "user-lists",
    components:{userEdit,pageTable},
    data() {
      return {
        showEditUser:false,
        editUserId:0,     //编辑的用户ID
        searchData: {
          account: '',
          group_id:''
        },
        tableColumn: [
          {title: '编号',key: 'uid'},
          {title: '账号',key: 'account'},
          {title: '姓名',key: 'name'},
          {title: '上次登录时间',key: 'last_login_time'},
          {title: '创建时间',key: 'create_time'},
          {title: '状态',key: 'status',render:(h,params)=>{
            let status = parseInt(params.row.status)
            return h('Tag',{
              props:{
                size: 'medium',
                color: status===1 ? 'default' : 'error'
              }
            },status===1 ? '正常' : '已禁用')
            }},
          {title: '操作',render:(h,params)=>{
            return h('div',[
              h('Button',{
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.row.uid)
                  }
                }
              },'查看'),
            ])
            }},
        ],
        tableData: [],
      }
    },
    methods: {
      cancelEdit(){
        this.showEditUser = false
      },
      edit(id){
        this.showEditUser = true
        this.editUserId = id || 0
      },
      editSuccess(){
        this.$refs.table.getLists(1)
        this.showEditUser = false
      }
    },


  }
</script>

<style scoped>

</style>
